export const countryOptions = [
  { text: 'United States', value: 'US' },
];
